export const convert24To12HourFormat = (time) => {
    time = time.split(":")

    let hour = parseInt(time[0])
    let min = time[1]
    let timeSuffix = "am"
    if(hour > 11){
        timeSuffix = "pm"
        if(hour > 12){
            hour = parseInt(time[0]) - 12
        }
    }
    
    let displayTime = hour + ":" + min + timeSuffix

    return displayTime
}

export const getTimeFromTimeSlot = (timeSlot, position) => {
    timeSlot = timeSlot.split(" ")

    let time = timeSlot[position].split(":")

    let timeSuffix = time[1].slice(-2)

    let hour = parseInt(time[0])
    
    if(timeSuffix === "pm"){
        if(hour < 12){
            hour = hour + 12
        }
    }
    
    if(hour < 10){
        hour = "0" + hour
    }

    let min = time[1].substring(0, time[1].length - 2)

    let t = hour + ":" + min
    
    return t
}

export const getMinAllowedTime = (serviceCategory) => {
    let minAllowed = "00:00"
    switch (serviceCategory) {
        case "Aircon Services":
            minAllowed = "09:00"
            break;
        case "Handyman Services":
            minAllowed = "09:00"
            break;
        case "Domestic Services":
            minAllowed = "08:00"
            break;
        case "Fitness Trainer":
            minAllowed = "06:00"
            break;
        default:
            break;
    }

    return minAllowed

}

export const getMaxAllowedTime = (serviceCategory) => {
    let maxAllowed = "00:00"
    switch (serviceCategory) {
        case "Aircon Services":
            maxAllowed = "21:00"
            break;
        case "Handyman Services":
            maxAllowed = "21:00"
            break;
        case "Domestic Services":
            maxAllowed = "17:00"
            break;
        case "Fitness Trainer":
            maxAllowed = "22:00"
            break;
        default:
            break;
    }

    return maxAllowed
}

export const getArrivalMaxTime = (minT) => {
    const minArrivalTime = parseInt(minT.substring(3))
    let arrivalMaxHour = 0
    let arrivalMaxMin = 0

    if (minArrivalTime < 30) {
        arrivalMaxHour = parseInt(minT.substring(0, 2))
        arrivalMaxMin = parseInt(minT.substring(3)) + 30
    } else {
        arrivalMaxHour = parseInt(minT.substring(0, 2)) + 1
        arrivalMaxMin = parseInt(minT.substring(3)) - 30
    }
    if (arrivalMaxHour < 10) {
        arrivalMaxHour = "0" + arrivalMaxHour
    }
    if (arrivalMaxHour === 24) {
        arrivalMaxHour = "00"
    }
    if (arrivalMaxHour > 24) {
        arrivalMaxHour = arrivalMaxHour - 24
        arrivalMaxHour = "0" + arrivalMaxHour
    }
    if (arrivalMaxMin == 0) {
        arrivalMaxMin = "00"
    } else {
        if (arrivalMaxMin < 10) {
            arrivalMaxMin = "0" + arrivalMaxMin
        }
    }

    return arrivalMaxHour + ":" + arrivalMaxMin
}

// Input expected → "03:00:00 pm" (12-hour string with meridian) OR "17:00:00" (24-hour format)
export const formatDisplayTime = (timeStr) => {
  if (!timeStr) return "";
  
  // Check if it's 24-hour format (no space/meridian)
  if (!timeStr.includes(" ")) {
    // Convert 24-hour to 12-hour format
    const [hh, mm] = timeStr.split(":");
    const hour = parseInt(hh, 10);
    const period = hour >= 12 ? "pm" : "am";
    const hour12 = hour % 12 === 0 ? 12 : hour % 12;
    return `${hour12}:${mm}${period}`;
  }
  
  // Original logic for 12-hour format with meridian ("03:00:00 pm")
  const [time, meridian] = timeStr.split(" ");
  let [hh, mm] = time.split(":");
  hh = String(parseInt(hh, 10));
  return `${hh}:${mm}${meridian.toLowerCase()}`;
};

export const to24HourFormat = (timeStr) => {
  if (!timeStr) return "";

  const [time, meridianRaw] = timeStr.trim().split(" ");
  let [hh, mm] = time.split(":");

  hh = parseInt(hh, 10);
  const meridian = meridianRaw?.toLowerCase();

  if (meridian === "pm" && hh !== 12) {
    hh += 12;
  }
  if (meridian === "am" && hh === 12) {
    hh = 0;
  }

  return `${hh.toString().padStart(2, "0")}:${mm}`;
};

// Input expected → "13:30" or "09:05" (24-hour format)
export const to12HourFormat = (time24) => {
  if (!time24) return "";
  const [hour, minute] = time24.split(":").map(Number);

  const period = hour >= 12 ? "pm" : "am";
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;

  return `${hour12}:${minute.toString().padStart(2, "0")}${period}`;
};

export const formatDateReadable = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

// "YYYY-MM-DD" -> true if Sunday. Parsed as a local date: new Date("YYYY-MM-DD") is UTC
// midnight and can land on the previous day in negative-offset timezones.
export const isSundayDateString = (dateStr) => {
    if (!dateStr) return false
    const [y, m, d] = dateStr.split("-").map(Number)
    return new Date(y, m - 1, d).getDay() === 0
}

function minsToTime(mins) {
    const h = Math.floor(mins / 60)
    const m = mins % 60
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
}

function timeToMins(time24) {
    const [h, m] = time24.split(':').map(Number)
    return h * 60 + m
}

export function calculateAvailableSlots(jobs, serviceCategory, serviceHours) {
    const minAllowed = getMinAllowedTime(serviceCategory)
    const maxAllowed = getMaxAllowedTime(serviceCategory)
    const minAllowedMins = timeToMins(minAllowed)
    const maxAllowedMins = timeToMins(maxAllowed)

    const intervals = jobs.map(job => ({
        start: timeToMins(to24HourFormat(job.startTime)),
        end: timeToMins(to24HourFormat(job.endTime))
    }))

    intervals.sort((a, b) => a.start - b.start)

    // merge overlapping
    const merged = []
    for (const interval of intervals) {
        if (!merged.length || merged[merged.length - 1].end < interval.start) {
            merged.push({start: interval.start, end: interval.end})
        } else {
            merged[merged.length - 1].end = Math.max(merged[merged.length - 1].end, interval.end)
        }
    }

    // now gaps
    const gaps = []
    let currentStart = minAllowedMins
    for (const interval of merged) {
        if (interval.start > currentStart) {
            gaps.push({start: currentStart, end: interval.start})
        }
        currentStart = Math.max(currentStart, interval.end)
    }
    if (currentStart < maxAllowedMins) {
        gaps.push({start: currentStart, end: maxAllowedMins})
    }

    // now for each gap, generate slots
    const slots = []
    const slotDurationMins = serviceHours * 60
    for (const gap of gaps) {
        if ((gap.end - gap.start) >= slotDurationMins) {
            let effectiveStart = gap.start
            const remainder = effectiveStart % 60
            if (remainder !== 0) {
                effectiveStart += 60 - remainder
            }
            if ((gap.end - effectiveStart) >= slotDurationMins) {
                for (let start = effectiveStart; start + slotDurationMins <= gap.end; start += 30) {
                    const end = start + slotDurationMins
                    slots.push({start: minsToTime(start), end: minsToTime(end)})
                }
            }
        }
    }

    return slots.filter(slot => slot.start.split(':')[1] === '00')
}

/**
 * Format datetime in WhatsApp chat style
 * - Today: "10:30 AM"
 * - Yesterday: "Yesterday 3:45 PM"  
 * - This week: "Mon 2:00 PM"
 * - Older: "25 Dec 2:00 PM" or "25 Dec 2024 2:00 PM" (if different year)
 * 
 * @param {string|Date} datetime - ISO string or Date object
 * @returns {string} Formatted time string
 */
export const formatWhatsAppTime = (datetime) => {
    if (!datetime) return "";
    
    const date = typeof datetime === 'string' ? new Date(datetime) : datetime;
    const now = new Date();
    
    // Get time string (12-hour format)
    const timeStr = date.toLocaleTimeString('en-US', { 
        hour: 'numeric', 
        minute: '2-digit',
        hour12: true 
    });
    
    // Check if same day (today)
    const isToday = date.toDateString() === now.toDateString();
    if (isToday) {
        return timeStr;
    }
    
    // Check if yesterday
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    const isYesterday = date.toDateString() === yesterday.toDateString();
    if (isYesterday) {
        return `Yesterday ${timeStr}`;
    }
    
    // Check if within this week (last 7 days)
    const weekAgo = new Date(now);
    weekAgo.setDate(weekAgo.getDate() - 6);
    const isThisWeek = date >= weekAgo;
    if (isThisWeek) {
        const dayName = date.toLocaleDateString('en-US', { weekday: 'short' });
        return `${dayName} ${timeStr}`;
    }
    
    // Check if same year
    const isSameYear = date.getFullYear() === now.getFullYear();
    if (isSameYear) {
        const day = date.getDate();
        const month = date.toLocaleDateString('en-US', { month: 'short' });
        return `${day} ${month} ${timeStr}`;
    }
    
    // Different year
    const day = date.getDate();
    const month = date.toLocaleDateString('en-US', { month: 'short' });
    const year = date.getFullYear();
    return `${day} ${month} ${year} ${timeStr}`;
};

/**
 * Format date for chat date separators (WhatsApp style)
 * - Today: "Today"
 * - Yesterday: "Yesterday"
 * - This week: "Monday", "Tuesday", etc.
 * - Older: "25 December 2024"
 * 
 * @param {string|Date} datetime - ISO string or Date object
 * @returns {string} Formatted date string
 */
export const formatWhatsAppDateSeparator = (datetime) => {
    if (!datetime) return "";
    
    const date = typeof datetime === 'string' ? new Date(datetime) : datetime;
    const now = new Date();
    
    // Check if same day (today)
    const isToday = date.toDateString() === now.toDateString();
    if (isToday) {
        return "Today";
    }
    
    // Check if yesterday
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    const isYesterday = date.toDateString() === yesterday.toDateString();
    if (isYesterday) {
        return "Yesterday";
    }
    
    // Check if within this week (last 7 days)
    const weekAgo = new Date(now);
    weekAgo.setDate(weekAgo.getDate() - 6);
    const isThisWeek = date >= weekAgo;
    if (isThisWeek) {
        return date.toLocaleDateString('en-US', { weekday: 'long' });
    }
    
    // Older dates
    return date.toLocaleDateString('en-US', { 
        day: 'numeric',
        month: 'long', 
        year: 'numeric' 
    });
};

export const formatDisplayDateTime = (isoString) =>
  new Date(isoString).toLocaleString('en-GB', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
});

export const formatDisplayDateIsoString = (isoString) =>
  new Date(isoString).toLocaleString('en-GB', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric'
});
